import Vue from 'vue';
import SlideItem from './SlideItem';

export default {
  data() {
    return {
      slides: [],
      currentSlide: 0,
      prevSlide: 0,
      totalSlides: null,
    };
  },
  props: {
    onNext: {
      type: Function,
      default: () => true,
    },
    onPrevious: {
      type: Function,
      default: () => true,
    },
    isCyclical: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateSlides() {
      //if (this.totalSlides === null) {
      this.slides = this.$slots.default.filter(
        (item) =>
          item.componentOptions &&
          item.componentOptions.Ctor === Vue.extend(SlideItem),
      );
      this.totalSlides = this.slides.length;
      //}
    },
    slide() {
      this.$nextTick(() => {
        this.updateSlides();

        for (let index = 0; index < this.totalSlides; index++) {
          this.slides[index].componentInstance.active =
            index === this.currentSlide;
        }

        this.$emit('onSlide', {
          first: this.currentSlide === 0,
          last: this.currentSlide === this.totalSlides - 1,
          item: this.slides[this.currentSlide].componentInstance.item || null,
        });
      });
    },
    previous() {
      if (this.onPrevious() === false) {
        this.$emit('onPreviousSlide', {
          previous: this.prevSlide,
          current: this.currentSlide,
        });
        return;
      }

      if (this.currentSlide !== 0) {
        this.prevSlide = this.currentSlide;
        this.currentSlide = this.currentSlide - 1;
        this.updateSlides();
        this.slide();
        // this.$nextTick(() => {
        //   //this.$emit('onSlide', {first: this.currentSlide === 0, last: false})
        //   // this.$emit("onPreviousSlide", {previous: this.prevSlide, current: this.currentSlide});
        // })
      }
    },

    next() {
      if (this.onNext() === false) {
        this.$emit('onNextSlide', {
          previous: this.prevSlide,
          current: this.currentSlide,
          onNext: this.onNext,
        });
        return;
      }

      this.prevSlide = this.currentSlide;
      let nextSlide = this.currentSlide + 1;
      this.updateSlides();

      if (this.isCyclical && nextSlide === this.totalSlides) {
        nextSlide = 0;
      }

      if (nextSlide >= 0 && nextSlide < this.totalSlides) {
        this.currentSlide = nextSlide;
        this.slide();
        // this.$nextTick(() => {
        //   //this.$emit('onSlide', {first: false, last: nextSlide === this.totalSlides-1})
        //   // this.$emit("onNextSlide", {previous: this.prevSlide, current: this.currentSlide, onNext:this.onNext});
        // })
      }
    },
  },
};
